const state = {
  unsavedData: false,
}

// getters
const getters = {
  unsavedData: state => state.unsavedData,
}

// actions
const actions = {
  unsavedData({ commit }, payload) {
    commit('unsavedData', payload)
  },
}

// mutations
const mutations = {
  unsavedData(state, data) {
    state.unsavedData = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
